import * as React from 'react';
export var AccordionItem = function AccordionItem(_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children;
  return React.createElement(React.Fragment, null, children);
};